import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { x } from '@xstyled/styled-components';
import { InfoItem, Section, SectionTitle, When } from '@aftersale-next/ui';
import { useEcommerceFeatures } from '@aftersale-next/atoms';
import { useTranslation } from 'react-i18next';
import { useDelivery } from '../../hooks/use-delivery';
import { useTrackingUrl } from '../../hooks/use-tracking-url';
import { useFormattedDeliveryDate } from '../../hooks/use-formatted-delivery-date';
import { getCourierName } from '../../utils/get-courier-name';
import { ExternalLink } from '../../../../ui/src/lib/text/external-link';
import { ECOMMERCE_FEATURES } from '../../config/constants/ecommerce-features';
export function DeliveryInfo() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useDelivery = useDelivery(),
      courier = _useDelivery.courier,
      trackingCode = _useDelivery.trackingCode,
      logisticProviderName = _useDelivery.logisticProviderName,
      invoiceUrl = _useDelivery.invoiceUrl;

  var trackingUrl = useTrackingUrl();
  var formattedDate = useFormattedDeliveryDate();

  var _useEcommerceFeatures = useEcommerceFeatures(),
      _useEcommerceFeatures2 = _slicedToArray(_useEcommerceFeatures, 1),
      features = _useEcommerceFeatures2[0];

  var shouldRenderInvoiceUrl = features.includes(ECOMMERCE_FEATURES.INVOICE_NOTIFICATION);

  if (!formattedDate && (!courier || courier === 'unknown') && !trackingCode) {
    return null;
  }

  return /*#__PURE__*/_jsxs(Section, {
    "data-testid": "delivery-info",
    children: [/*#__PURE__*/_jsx(x.div, {
      pb: "32px",
      "data-testid": "delivery-info-section-title",
      children: /*#__PURE__*/_jsx(SectionTitle, {
        children: t('DELIVERY_DATA')
      })
    }), /*#__PURE__*/_jsxs(x.div, {
      display: "grid",
      gridTemplateColumns: {
        _: 1,
        md: 2
      },
      rowGap: "16px",
      children: [/*#__PURE__*/_jsx(When, {
        value: !!courier && courier !== 'unknown',
        children: /*#__PURE__*/_jsx(InfoItem, {
          label: t('COURIER'),
          value: /*#__PURE__*/_jsx(Courier, {
            courier: courier,
            trackingUrl: trackingUrl,
            logisticProviderName: logisticProviderName
          })
        })
      }), /*#__PURE__*/_jsx(When, {
        value: !!trackingCode,
        children: /*#__PURE__*/_jsx(InfoItem, {
          label: t('TRACKING_NUMBER'),
          value: trackingCode
        })
      }), /*#__PURE__*/_jsx(When, {
        value: !!formattedDate,
        children: /*#__PURE__*/_jsx(InfoItem, {
          label: t('DELIVERY_ESTIMATION'),
          value: formattedDate
        })
      }), !!invoiceUrl && shouldRenderInvoiceUrl && /*#__PURE__*/_jsx(InfoItem, {
        label: t('INVOICE_LINK'),
        value: /*#__PURE__*/_jsx(ExternalLink, {
          link: invoiceUrl
        })
      })]
    })]
  });
}

function Courier(_ref) {
  var courier = _ref.courier,
      trackingUrl = _ref.trackingUrl,
      logisticProviderName = _ref.logisticProviderName;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(When, {
      value: courier && trackingUrl,
      children: /*#__PURE__*/_jsx(x.a, {
        href: trackingUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        children: getCourierName(logisticProviderName || courier)
      })
    }), /*#__PURE__*/_jsx(When, {
      value: courier && !trackingUrl,
      children: getCourierName(logisticProviderName || courier)
    })]
  });
}